import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class PickListAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "PickList";

  /**
   * Lấy dữ liệu combobox
   */
  getComboboxData(type) {
    let request = {
      url: [this.getAPIUrl(), "combobox", type].join("/"),
    };

    return httpClient.getAsync(request);
  }
}

export default new PickListAPI();
